/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SSRTextPlacementContentAllOfContentData {
    /**
    * JSON encoded HTML content, typically a fully rendered placement.
    */
    'htmlContent'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "htmlContent",
            "baseName": "htmlContent",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SSRTextPlacementContentAllOfContentData.attributeTypeMap;
    }
    
    public constructor() {
    }
}

